module.exports = __webpack_public_path__ + "static/media/icon_lose_body_fat.4a0353a0.png";